import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { FormControl, FormGroup, Col, ControlLabel } from 'react-bootstrap';
import VirtualizedSelect from 'react-virtualized-select';
import asyncValidate from '../../asyncValidate';
import './styles.css';

const validate = values => {
  const errors = {};
  return errors;
};

const renderField = ({ feedbackIcon, input, label, type, meta: { touched, error, warning, asyncValidating } }) => {
  const validationState = (touched && (error && 'error')) || (warning && 'warning') || null;
  const style = { margin: '10px 0', borderRadius: 0, color: '#265886' };
  return (
    <FormGroup controlId={input.name} validationState={validationState}>
      <Col componentClass={ControlLabel} xs={12} md={5} className="text-right">
        <div style={style}>
          <h4>
            {label}
            {input.name === 'address2' ? null : <span style={{ color: 'red' }}> *</span>}
          </h4>
        </div>
      </Col>
      <Col xs={12} md={7}>
        <FormControl {...input} placeholder={label} type={type} style={style} />
        {asyncValidating ? (
          <FormControl.Feedback style={{ width: '34px', height: 'inherit', right: '25px', top: '20px' }}>
            <i className="fa fa-spinner fa-spin" />
          </FormControl.Feedback>
        ) : null}
        {feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
        {touched &&
          ((error && <span className="help-block text-left">{error}</span>) ||
            (warning && <span className="help-block text-left">{warning}</span>))}
      </Col>
    </FormGroup>
  );
};

const renderSelect = ({
  options,
  placeholder,
  feedbackIcon,
  input,
  label,
  type,
  lastBlurredField,
  meta: { touched, error, warning, asyncValidating }
}) => {
  const validationState = (touched && (error && 'error')) || (warning && 'warning') || null;
  const style = { margin: '10px 0', borderRadius: 0, color: '#265886' };

  return (
    <FormGroup controlId={input.name} validationState={validationState}>
      <Col componentClass={ControlLabel} xs={12} md={5} className="text-right">
        <div style={style}>
          <h4>
            {label}
            {input.name === 'address2' ? null : <span style={{ color: 'red' }}> *</span>}
          </h4>
        </div>
      </Col>
      <Col xs={12} md={7} className="text-left">
        <VirtualizedSelect
          labelKey="name"
          value={input.value}
          onChange={value => input.onChange(value)}
          onBlur={() => input.onBlur(input.value)}
          simpleValue
          options={options}
          valueKey="code"
          style={style}
          placeholder={placeholder}
          onFocus={() => lastBlurredField('country')}
        />
        {asyncValidating ? (
          <FormControl.Feedback style={{ right: '25px', top: '20px' }}>
            <i className="fa fa-spinner fa-spin" />
          </FormControl.Feedback>
        ) : null}
        {feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
        {touched &&
          ((error && <span className="help-block text-left">{error}</span>) ||
            (warning && <span className="help-block text-left">{warning}</span>))}
      </Col>
    </FormGroup>
  );
};

const SyncValidationForm = props => {
  const { handleSubmit } = props;
  return (
    <form onSubmit={handleSubmit} className="address-form">
      <Field
        name="firstName"
        type="text"
        component={renderField}
        label="First Name"
        onFocus={() => props.lastBlurredField('firstName')}
      />
      <Field
        name="lastName"
        type="text"
        component={renderField}
        label="Last Name"
        onFocus={() => props.lastBlurredField('lastName')}
      />
      <Field
        name="country"
        type="select"
        component={renderSelect}
        label="Country"
        options={props.info.paymentCountries}
        placeholder="Select Country"
        lastBlurredField={props.lastBlurredField}
      />
      <Field
        name="postcode"
        type="text"
        component={renderField}
        label="Post Code/Zip"
        onFocus={() => props.lastBlurredField('postcode')}
      />
      <Field
        name="address1"
        type="text"
        component={renderField}
        label="Address Line 1"
        onFocus={() => props.lastBlurredField('address1')}
      />
      <Field
        name="address2"
        type="text"
        component={renderField}
        label="Address Line 2"
        onFocus={() => props.lastBlurredField('address2')}
      />
      <Field
        name="city"
        type="text"
        component={renderField}
        label="City"
        onFocus={() => props.lastBlurredField('city')}
      />
    </form>
  );
};

export default reduxForm({
  form: 'payment', // a unique identifier for this form
  asyncValidate,
  validate // <--- validation function given to redux-form
  // warn // <--- warning function given to redux-form
})(SyncValidationForm);



// WEBPACK FOOTER //
// ./src/containers/PaymentPage/PersonalDetails/form/index.js